(ns common.schema.entities.survey-batch.schema
  (:require
   [common.schema.entities.survey-batch.options :as options]
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/text-simple-field :survey-batch/batch-label
                          "Label"
                          {:authorization            su/access-user-user
                           :default-field-visibility :in-use-disabled})
    (su/keyword-field :survey-batch/batch-status
                      "Status"
                      options/batch-status-options
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
    (su/datetime-field :survey-batch/sent-at
                       "Sent at"
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use-disabled})
    (su/datetime-field :survey-batch/batch-deadline-override
                       "Deadline override"
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use-disabled})
    ;; The profile owns the CC list; the sender decides per batch whether it is
    ;; used. Stored on the batch rather than passed at send time because
    ;; reminders go out later - often unattended - and have to honour the same
    ;; decision the person who sent the batch made.
    (su/boolean-field :survey-batch/include-cc?
                      "Copy CC recipients"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
    (su/multi-ref-field :survey-batch/survey-processes
                        "Survey processes"
                        [:entity.type/survey-process]
                        {:authorization            su/access-user-user
                         :editor-type              :editor.type/none
                         :grid-type                :editor.type/none
                         :filter-type              :filter.type/none
                         :default-field-visibility :in-use-disabled}))))
